<template>
  <el-col>
    <el-row>
      First Response Due:<br>
      {{ $moment(enquiry.fr_due_by).format('DD-MM-YYYY HH:mm:ss') }}
    </el-row>
    <br>
    <el-row>
      Resolution Due:<br>
      {{ $moment(enquiry.due_by).format('DD-MM-YYYY HH:mm:ss') }}
    </el-row>
    <br>
    <hr>
    <h3>Properties</h3>
    <br>
    <el-row>
      Tags:<br>
      {{ $_.get(flattenTags()) || '-' }}
    </el-row>
    <br>
    <el-row>
      Customer:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_billing_code') || '-' }}
    </el-row>
    <br>
    <el-row>
      Consignment:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_consignment') || '-' }}
    </el-row>
    <br>
    <el-row>
      Carrier:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_carrier') || '-' }}
    </el-row>
    <br>
    <el-row>
      Type:<br>
      {{ $_.get(enquiry, 'type') || '-' }}
    </el-row>
    <br>
    <el-row>
      Special Attention:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_special_attention') || '-' }}
    </el-row>
    <br>
    <el-row>
      Team:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_team') || '-' }}
    </el-row>
    <br>
    <el-row>
      Freight Investigator:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_freight_investigator') || '-' }}
    </el-row>
    <br>
    <el-row>
      Portfolio:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_portfolio') || '-' }}
    </el-row>
    <br>
    <el-row>
      Customer Grade:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_customer_grade') || '-' }}
    </el-row>
    <br>
    <el-row>
      Value of Freight:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_value_of_freight') || '-' }}
    </el-row>
    <br>
    <el-row>
      Freight Description:<br>
      {{ $_.get(enquiry.custom_fields, 'cf_freight_description') || '-' }}
    </el-row>
    <br>
  </el-col>
</template>
<script>
export default {
  props: {
    enquiry: {
      type: Object,
      required: true
    }
  },
  methods: {
    flattenTags () {
      return this.enquiry.tags.join(',')
    }
  }
}
</script>
